import React from 'react'
import LayoutContainer from './shared/LayoutContainer'
import Text from './shared/Text'
import Detail from './shared/Detail'

const Donations = () => {
  return (
    <LayoutContainer>
      <h2>Spenden</h2>
      <Text>
        Laut Feststellungsbescheid des Finanzamts Bad Urach vom 24. November 2023
        fördert der Verein <b>Mt.Olives Prayer & Worship</b> gemeinnützige
        Zwecke im Sinne der §51ff. AO. Der Verein ist berechtigt, für Spenden
        zur Verwendung für diese Zwecke Zuwendungsbescheinigungen auszustellen.
      </Text>
      <Text>Unsere Kontodaten:</Text>
      <Text>
        <Detail description="Name" content="Mt.Olives Prayer & Worship" />
        <Detail description="Bank" content="Vereinigte Volksbanken eG" />
        <Detail description="IBAN" content="DE06 6039 0000 0739 7020 09" />
        <Detail description="BIC" content="GENODES1BBV" />
      </Text>
      <Text>
        Bitte geben Sie bei Spenden im Verwendungszweck Ihren Namen und die
        vollständige Anschrift an. Andernfalls sind wir nicht in der Lage, Ihnen
        eine Spendenbescheinigung zuzusenden.
      </Text>
    </LayoutContainer>
  )
}

export default Donations



// WEBPACK FOOTER //
// ./src/components/Donations.js